import { compose } from "redux";

import DetailedGroup from "./Detailed";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import injectLayoutWithQuickLinks from "../InjectLayoutWithQuickLinks";
import extractId from "../ExtractId";

import { getObjectById } from "../../services/MODSService";

const type = "Group";
export default compose(
    extractId(),
    withContainer({
        dataParams: {
            fetchHandler: getObjectById
        },
        defaultLoadingMessage: "Loading Group",
        Error,
        DefaultComponent: Default
    }),
    injectLayoutWithQuickLinks(type)
)(DetailedGroup);
